import { Component, ViewChild } from '@angular/core';
import { Nav, Platform ,AlertController,ViewController,App,Events} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';
import { DetailPage } from '../pages/detail/detail';
import { Network } from '@ionic-native/network';
import { Geolocation } from '@ionic-native/geolocation'
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

 // rootPage: any = HomePage;
 // rootPage: any = LoginPage;
  rootPage:any;
  pages: Array<{title: string, component: any}>;
 user_namenav: any;
 car_number:any;
 profile_pic:any;
 //leerauftrag : any;
  constructor(public platform: Platform,private alertCtrl: AlertController, public statusBar: StatusBar, public splashScreen: SplashScreen,public network: Network,public events: Events) {
   this.events.subscribe("userloggedin", (user) => {
     console.log(user);
    this.user_namenav=user.name;
   this.car_number=user.car_number;
   this.profile_pic=user.profile_pic;
   
});
    this.initializeApp();

if((localStorage.getItem('driver_id') === "undefined"  ) || (localStorage.getItem('driver_id') == null )) {


  } else {
 
   this.user_namenav=localStorage.getItem('name');
   this.car_number=localStorage.getItem('car_number');
   this.profile_pic=localStorage.getItem('profile_pic');
   //this.leerauftrag=localStorage.getItem('leerauftrag');


   }
    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Ihre Auftragsliste', component: HomePage },
      { title: 'Auftrag erstellen (ohne Fahrgast)', component: ListPage },
    //  { title: 'Login', component: LoginPage },
      {title: 'Logout', component:null}
    ];

  }
ionViewWillEnter() {
     this.user_namenav=localStorage.getItem('name');
   this.car_number=localStorage.getItem('car_number');
   this.profile_pic=localStorage.getItem('profile_pic');
   //this.leerauftrag=localStorage.getItem('leerauftrag');

  /*  this.events.subscribe("userloggedin", (user) => {
    console.log(user);
        this.user_namenav=localStorage.getItem('name');
   this.car_number=localStorage.getItem('car_number');
   this.profile_pic=localStorage.getItem('profile_pic');

    });*/

    this.events.subscribe("userloggedin", (user) => {
     console.log(user);
    this.user_namenav=user.name;
   this.car_number=user.car_number;
   this.profile_pic=user.profile_pic;
});
    }
  initializeApp() {
    this.platform.ready().then(() => {
     
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if((localStorage.getItem('driver_id') === "undefined"  ) || (localStorage.getItem('driver_id') == null )) {


  } else {
 
 

   }
      let disconnectSub = this.network.onDisconnect().subscribe(() => {
 alert('Bitte prüfen Sie Ihre Internetverbindung!');
});

let connectSub = this.network.onConnect().subscribe(()=> {
  console.log('you are online');
});


    });

    if((localStorage.getItem('driver_id') === "undefined"  ) || (localStorage.getItem('driver_id') == null )) {

   // alert(22);
    this.rootPage = LoginPage
  } else {

setTimeout(function(){ 
   this.user_namenav=localStorage.getItem('name');
   this.car_number=localStorage.getItem('car_number');
   this.profile_pic=localStorage.getItem('profile_pic');
    }, 2000);
  
   

   
   this.rootPage = HomePage;
   }
   
  }
  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Wollen Sie wirklich abmelden?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
        //  this.nav.remove(index);
          // this.navCtrl.rootNav.setRoot(LoginsignupPage);  
  
           // this.viewCtrl.dismiss();
         //  this.appCtrl.getRootNav().setRoot(LoginPage);
           //this.navCtrl.setRoot(LoginsignupPage);  
           localStorage.clear();
           this.nav.setRoot(LoginPage);
          }
        }
      ]
    });
    alert.present();
  }

  openPage(page) {
    if (page.title === 'Logout') {
      //alert(1212);
      this.presentConfirm();
   
    
    }
    else{
      this.nav.setRoot(page.component);
    }
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
   
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts